'use strict'
const helperProvider = {}
helperProvider.handleLoginErrorMsg = function (response) {
  console.log(response.data.error_code)
  switch (response.data.error_code) {
    case 2001:
      return '用户未注册，请联系管理员'
    case 2002:
      return '用户名/密码错误'
    case 2003:
      return '用户名/密码错误'
  }
}
helperProvider.handleTimeStamp = function (timeStamp) {
  return new Date(parseInt(timeStamp) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ')
}
export default helperProvider



// WEBPACK FOOTER //
// ./src/common/provider/helper.provider.js